export const exclusiveAccessDeLegacy = {
  "exclusiveSetupPage.title.new": "Neuer Zugriff auf {value} ",
  "stylePickerBar.notificationContent.Member":
    "Überschreiben Sie den Drucktastentext und die URL für Treueprogrammmitglieder, die keinen exklusiven Zugriff haben.",
  "stylePickerBar.notificationContent.nonMember":
    "Überschreiben Sie den Drucktastentext und die URL für Nicht-Mitglieder, die keinen exklusiven Zugriff haben.",
  "memberModTabs.template.value": "Allgemein: Design und Text wirken sich auf alle Bilder aus."
};
